import { defineSlotRecipe } from '@chakra-ui/react';

// v2 parts list/item/groupTitle/command → v3 slots content/item/itemGroupLabel/
// itemCommand. mode(light, dark) collapsed to the light value.
const menuSlotRecipe = defineSlotRecipe({
  slots: ['content', 'item', 'itemGroupLabel', 'itemCommand'],
  base: {
    content: {
      bg: '#fff',
      boxShadow: '2xl',
      color: 'inherit',
      zIndex: 'docked',
      borderRadius: 'md',
      borderWidth: 0,
      overflow: 'hidden',
    },
    item: {
      fontSize: 'sm',
      transition: 'background 50ms ease-in 0s',
      _focus: {
        bg: 'blue.50',
      },
      _hover: {
        bg: 'blue.50',
      },
      _active: {
        bg: 'gray.200',
      },
      _expanded: {
        bg: 'gray.100',
      },
      _disabled: {
        opacity: 0.4,
        cursor: 'not-allowed',
      },
    },
    itemGroupLabel: {
      mx: 4,
      my: 2,
      fontWeight: 'semibold',
      fontSize: 'sm',
    },
    itemCommand: {
      opacity: 0.6,
    },
  },
  // v2's MenuList/MenuItem geometry. Must be a size variant, not base — v3 puts
  // its own in `size.md` and variants win, which is why base values here were
  // being silently overridden.
  variants: {
    size: {
      md: {
        content: { minW: '3xs', px: 0, py: 2 },
        item: { py: 2, px: 4 },
      },
    },
  },
});

export default menuSlotRecipe;
